

/**
 * @memberOf app
 * @ngdoc filter
 * @name app.filter:suffix
 * @function
 * @description
 * # humanSize
 * Filter in the app.
 */
angular.module('app')
	.filter('suffix', /* @ngInject */ function () {
		return function (input) {
			return input.split(';').splice(0, 1).join(';');
		};
	});
